import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  InputAdornment,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
} from "@mui/material";
import { DateIconSvg, ListIconSvg, PersonIconSvg } from "../../images/SvgIcons";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { userRole } from "../comman/Constant";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const modelFilterInitial = {
  userRole: "",
  accountActive: "",
  archivedUserStatus: "",
  accountActiveYes: "",
  accountActiveNo: "",
};

export default function UserFilter(props) {
  const {
    open,
    handleClose,
    filterValue,
    setFilterValue,
    applyFilterFun,
    isOnlyAdmin,
  } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [ modelFilter, setModelFilter] = useState(modelFilterInitial);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  useEffect(() => {
    console.log("filterValue", filterValue)
    setModelFilter(filterValue)
  }, []);

  const handleChangeUserStatus = (val) => {
    if (val === "yes") {
      if (modelFilter.accountActiveYes) {
        setModelFilter({ ...modelFilter, accountActiveYes: false });
      } else {
        setModelFilter({ ...modelFilter, accountActiveYes: true });
      }
    }
    if (val === "no") {
      if (modelFilter.accountActiveNo) {
        setModelFilter({ ...modelFilter, accountActiveNo: false });
      } else {
        setModelFilter({ ...modelFilter, accountActiveNo: true });
      }
    }
  };

  const handleChangeArchivedUserStatus = () => {
    setModelFilter({
      ...modelFilter,
      archivedUserStatus: !modelFilter.archivedUserStatus,
    });
  };

  const handleChangeUser = (e) => {
    setModelFilter({ ...modelFilter, userRole: e.target.value });
  };

  // useEffect(() => {
  //   let userStatusYes = modelFilter.accountActiveYes;
  //   let userStatusNo = modelFilter.accountActiveNo;

  //   console.log("userStatusYes", userStatusYes)
  //   console.log("userStatusNo", userStatusNo)

  //   if (userStatusYes && userStatusNo) {
  //     setModelFilter({ ...modelFilter, accountActive: "" });
  //   } else if (!userStatusYes && !userStatusNo) {
  //     setModelFilter({ ...modelFilter, accountActive: "" });
  //   } else if (userStatusYes && !userStatusNo) {
  //     setModelFilter({ ...modelFilter, accountActive: true });
  //   } else if (!userStatusYes && userStatusNo) {
  //     setModelFilter({ ...modelFilter, accountActive: false });
  //   }
  // }, [modelFilter.accountActiveYes, modelFilter.accountActiveNo]);


  const submitFilterFilter = () => {
    setFilterValue((prevState) => ({
      ...prevState,
      userRole: modelFilter.userRole,
      accountActive: modelFilter.accountActive,
      archivedUserStatus: modelFilter.archivedUserStatus,
      accountActiveYes: modelFilter.accountActiveYes,
      accountActiveNo: modelFilter.accountActiveNo
    }));
    setIsFormSubmitted(true)
  }

  useEffect(() => {
    if(isFormSubmitted){
      applyFilterFun();
    }
  }, [isFormSubmitted]);

  // onClick={applyFilterFun} 


  // const handleChangeUserStatus = (val) => {
  //   if (val === "yes") {
  //     if (filterValue.accountActiveYes) {
  //       setFilterValue({ ...filterValue, accountActiveYes: false });
  //     } else {
  //       setFilterValue({ ...filterValue, accountActiveYes: true });
  //     }
  //   }
  //   if (val === "no") {
  //     if (filterValue.accountActiveNo) {
  //       setFilterValue({ ...filterValue, accountActiveNo: false });
  //     } else {
  //       setFilterValue({ ...filterValue, accountActiveNo: true });
  //     }
  //   }
  // };

  // const handleChangeArchivedUserStatus = () => {
  //   setFilterValue({
  //     ...filterValue,
  //     archivedUserStatus: !filterValue.archivedUserStatus,
  //   });
  // };

  // const handleChangeUser = (e) => {
  //   setFilterValue({ ...filterValue, userRole: e.target.value });
  // };

  // useEffect(() => {
  //   let userStatusYes = filterValue.accountActiveYes;
  //   let userStatusNo = filterValue.accountActiveNo;

  //   if (userStatusYes && userStatusNo) {
  //     setFilterValue({ ...filterValue, accountActive: "" });
  //   } else if (!userStatusYes && !userStatusNo) {
  //     setFilterValue({ ...filterValue, accountActive: "" });
  //   } else if (userStatusYes && !userStatusNo) {
  //     setFilterValue({ ...filterValue, accountActive: true });
  //   } else if (!userStatusYes && userStatusNo) {
  //     setFilterValue({ ...filterValue, accountActive: false });
  //   }
  // }, [filterValue.accountActiveYes, filterValue.accountActiveNo]);


  return (
    <>
      <Dialog
        className="user-filter-popup user-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "26px 34px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">Filter Properties</Typography>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          <Stack direction="row" alignItems="center" spacing={4.5}>
            <FormControl
              // className="search-box"
              sx={{ m: 1, width: "100%", maxWidth: "350px" }}
            >
              <p className="label">User Role:</p>
              <Select
                sx={{
                  // Styles for the select component
                  "& .MuiSelect-select": {
                    color: modelFilter.userRole.length === 0 ? "#898989" : "#212121",
                  },
                  // Styles for placeholder text color
                  "& .MuiSelect-select:empty": {
                    color: "#898989",
                  },
                }}
                labelId="demo-select-small-label"
                id="demo-select-small"
                displayEmpty
                multiple
                value={modelFilter.userRole || []}
                onChange={handleChangeUser}
                IconComponent={KeyboardArrowDownIcon}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <span>Select Role</span>; // Placeholder text
                  }
                  return selected.map(id => userRole.find(role => role.id === id)?.role).join(', ');
                }}
              >
                <MenuItem disabled value="">
                Select Role
                </MenuItem>

                {userRole.map((role) => (
                  <MenuItem key={role.id} value={role.id}>
                    {role.role}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Box>
              <p className="label">Status:</p>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-start"
                spacing={2}
              >
                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      name="UserStatus"
                      id="UserStatusYes"
                      onChange={() => handleChangeUserStatus("yes")}
                      checked={modelFilter.accountActiveYes}
                      // disabled={editFlag}
                      sx={{ color: "gray" }}
                    />
                  }
                  label="Active"
                />

                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      name="UserStatus"
                      id="UserStatusNo"
                      // disabled={editFlag}
                      onChange={() => handleChangeUserStatus("no")}
                      checked={modelFilter.accountActiveNo}
                      sx={{ color: "gray" }}
                    />
                  }
                  label="Inactive"
                />
              </Stack>
            </Box>
          </Stack>

          {/* Archive User Start*/}
          {isOnlyAdmin ? (
            <Stack
              direction="row"
              alignItems="center"
              spacing={4.5}
              style={{ marginTop: "20px" }}
            >
              <Box>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-start"
                  spacing={2}
                >
                  <p className="label">Archived User</p>
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="ArchivedUser"
                        id="ArchivedUser"
                        onChange={handleChangeArchivedUserStatus}
                        checked={modelFilter.archivedUserStatus === true}
                        // disabled={editFlag}
                        sx={{ color: "gray" }}
                      />
                    }
                  />
                </Stack>
              </Box>
            </Stack>
          ) : (
            ""
          )}

          {/* Archive User End*/}
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 34px", mt: "35px" }}
        >
          <Button className="filter-btn" onClick={submitFilterFilter} >
            Apply Filter
          </Button>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
